import { Helpers } from "./Helpers";

export interface IDataFrame<T>
{
    Resource?: string;
    TransactionId?: string;
    Data?: T;
    Status?: Status;
    Method?: Method;
}

export class DataFrame<T> implements IDataFrame<T>
{
    Resource?: string;
    TransactionId?: string = Helpers.GenerateUUID();
    Data?: T;
    Status?: Status;
    Method?: Method;
}

export enum Status
{
    /// <summary>
    /// Gdy zapytanie się powiodło i nie wystąpiły błędy
    /// </summary>
    OK = 0,

    /// <summary>
    /// Gdy wystąpił nieznany błąd podczas wykonywania zapytania
    /// </summary>
    UnknownError = 1,

    /// <summary>
    /// Gdy wystąpił błąd którego oprogramowanie kontrolera nie mogło rozwiązać
    /// </summary>
    FatalError = 2,

    /// <summary>
    /// Gdy zapytanie zostało wykonane z niepoprawnymi danymi
    /// </summary>
    WrongData = 3,

    /// <summary>
    /// Gdy zostało wykonane zapytanie do zasobu który nie istnieje
    /// </summary>
    ResourceDoesNotExists = 4,

    /// <summary>
    /// Gdy zostało wykonane zapytanie o wykonanie operacji do której zalogowany użytkownik nie ma uprawnień (np. gdy próbuje zmienić dane użytkownika o uprawnieniach wyższych od siebie)
    /// </summary>
    NoPermissionToPerformThisOperation = 5,

    /// <summary>
    /// Gdy zostanie dokonana próba ponownego logowania dla już zalogowanej sesji
    /// </summary>
    SessionHasAlreadyLoggedOnUser = 6,

    /// <summary>
    /// Gdy żądana operacja jest niedozwolona
    /// </summary>
    OperationNotPermitted = 7,

    /// <summary>
    /// Gdy zostanie wykonane zapytanie do zasobu do którego użytkownik nie ma uprawnień
    /// </summary>
    NoPermissionsToCallGivenResource = 8,

    /// <summary>
    /// Gdy zostanie wykonane zapytanie do zasobu aktualnie nie dostępnego (gdy np. zasób został wyłączony)
    /// </summary>
    ResourceIsNotAvailable = 9,

    /// <summary>
    /// Gdy zapytanie do zasobu zakończyło się okreslonym błędem
    /// </summary>
    Error = 10,

    /// <summary>
    /// Gdy w ramach odpowiedzi na zapytanie nie są zwracane dane
    /// </summary>
    NoData = 11,

    /// <summary>
    /// Gdy zostanie wykonane zapytanie do nie wspieranego zasobu (np. dotyczącego okreslonego systemu operacyjnego)
    /// </summary>
    NotSupportedMethod = 12,

    /// <summary>
    /// Gdy zostanie wykonane zapytanie do dowolnego zasobu a żaden użytkownik nie jest zalogowany w ramach sesji
    /// </summary>
    UserIsNotLoggedIn = 13,
    /// <summary>
    /// Przewidziane dla zapytań które zwracają wiele odpowiedzi, np. postęp w realizacji jakiegoś procesu
    /// </summary>
    MultiDataResponseStart = 14,
    /// <summary>
    /// Przewidziane dla zapytań które zwracają wiele odpowiedzi, np. postęp w realizacji jakiegoś procesu. Informuje, że dana odpowiedź jest jedną z odpowiedzi
    /// </summary>
    MultiDataResponse = 15,
    /// <summary>
    /// Przewidziane dla zapytań które zwracają wiele odpowiedzi, np. postęp w realizacji jakiegoś procesu. Informuje, że dana odpowiedź jest ostatnią odpowiedzią danego zasobu
    /// </summary>
    MultiDataResponseStop = 16
}


export enum Method
{
    Get = 0,
    Post = 1,
    Delete = 2,
    Put = 3,
    Options = 4,
    Head = 5
}